const BASKET_TYPES = {
    PREBASKET: 'prebasket',
    // DC_BASKET = SAMEDAY_BASKET | STANDARD_BASKET
    DC_BASKET: 'distribution center basket',
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket',
    SAMEDAY_BASKET: 'SameDay',
    STANDARD_BASKET: 'ShipToHome'
};

const ROOT_BASKET_TYPES = {
    PRE_BASKET: 'PRE_BASKET',
    MAIN_BASKET: 'MAIN_BASKET'
};

const MAIN_BASKET_TYPES = {
    DC_BASKET: 'distribution center basket',
    BOPIS_BASKET: 'buy online and pick up basket'
};

const BOPIS_TYPES = {
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket'
};

const DC_BASKET_TYPES = {
    // TODO subtypes of SAMEDAY i.e SDUonly
    SAMEDAY_BASKET: 'SameDay',
    STANDARD_BASKET: 'ShipToHome',
    AUTOREPLENISH_BASKET: 'Autoreplenish'
};

// MOCK DATA
const STORE_DETAILS = {
    address: {
        address1: '33 Powell Street',
        address2: '',
        city: 'San Francisco',
        country: 'US',
        crossStreet: 'Powell & Market Streets',
        fax: '',
        mallName: '',
        phone: '(415) 362-9360',
        postalCode: '94102',
        state: 'CA'
    },
    displayName: 'Powell',
    distance: 0,
    isBopisable: true,
    isConciergeCurbsideEnabled: false,
    isCurbsideEnabled: false,
    isRopisable: false,
    latitude: 37.785,
    longitude: -122.408,
    seoCanonicalUrl: '/happening/stores/san-francisco-powell-street',
    storeHours: {
        closedDays: 'For the health and safety of our clients and associates, store hours may vary. Call your local store for operating hours.',
        fridayHours: '09:00AM-06:00PM',
        mondayHours: '09:00AM-06:00PM',
        saturdayHours: '',
        sundayHours: '09:00AM-06:00PM',
        textColor: 'Black',
        thursdayHours: '09:00AM-06:00PM',
        timeZone: 'PST8PDT',
        tuesdayHours: '09:00AM-06:00PM',
        wednesdayHours: '09:00AM-06:00PM'
    },
    storeId: '0058',
    storeSpecialMessage: 'For the health and safety of our clients and associates, store hours may vary. Call your local store for operating hours.',
    storeType: 'SEPHORA',
    targetUrl: '/happening/stores/san-francisco-powell-street'
};

const PRODUCTS = [
    {
        sku: {
            skuId: '1966258',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s1966258-main-grid.jpg?pb=2020-03-allure-readers-choice-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s1966258-162.jpg?pb=2020-03-allure-readers-choice-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s1966258-main-hero.jpg?pb=2020-03-allure-readers-choice-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lhero.jpg?pb=2020-03-allure-readers-choice-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lthumb.jpg?pb=2020-03-allure-readers-choice-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Sgrid.jpg?pb=2020-03-allure-readers-choice-2019'
            }
        }
    },
    {
        sku: {
            skuId: '2597268',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s2597268-main-grid.jpg?pb=2020-03-sephora-clean-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s2597268-162.jpg?pb=2020-03-sephora-clean-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s2597268-main-hero.jpg?pb=2020-03-sephora-clean-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lhero.jpg?pb=2020-03-sephora-clean-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lthumb.jpg?pb=2020-03-sephora-clean-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Sgrid.jpg?pb=2020-03-sephora-clean-2019'
            }
        }
    },
    {
        sku: {
            skuId: '1966258',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s1966258-main-grid.jpg?pb=2020-03-allure-readers-choice-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s1966258-162.jpg?pb=2020-03-allure-readers-choice-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s1966258-main-hero.jpg?pb=2020-03-allure-readers-choice-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lhero.jpg?pb=2020-03-allure-readers-choice-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lthumb.jpg?pb=2020-03-allure-readers-choice-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Sgrid.jpg?pb=2020-03-allure-readers-choice-2019'
            }
        }
    },
    {
        sku: {
            skuId: '2597268',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s2597268-main-grid.jpg?pb=2020-03-sephora-clean-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s2597268-162.jpg?pb=2020-03-sephora-clean-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s2597268-main-hero.jpg?pb=2020-03-sephora-clean-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lhero.jpg?pb=2020-03-sephora-clean-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lthumb.jpg?pb=2020-03-sephora-clean-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Sgrid.jpg?pb=2020-03-sephora-clean-2019'
            }
        }
    },
    {
        sku: {
            skuId: '1966258',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s1966258-main-grid.jpg?pb=2020-03-allure-readers-choice-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s1966258-162.jpg?pb=2020-03-allure-readers-choice-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s1966258-main-hero.jpg?pb=2020-03-allure-readers-choice-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lhero.jpg?pb=2020-03-allure-readers-choice-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Lthumb.jpg?pb=2020-03-allure-readers-choice-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s1966258-main-Sgrid.jpg?pb=2020-03-allure-readers-choice-2019'
            }
        }
    },
    {
        sku: {
            skuId: '2597268',
            skuImages: {
                image135: 'https://qa4.sephora.com/productimages/sku/s2597268-main-grid.jpg?pb=2020-03-sephora-clean-2019',
                image162: 'https://qa4.sephora.com/productimages/sku/s2597268-162.jpg?pb=2020-03-sephora-clean-2019',
                image250: 'https://qa4.sephora.com/productimages/sku/s2597268-main-hero.jpg?pb=2020-03-sephora-clean-2019',
                image450: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lhero.jpg?pb=2020-03-sephora-clean-2019',
                image62: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Lthumb.jpg?pb=2020-03-sephora-clean-2019',
                image97: 'https://qa4.sephora.com/productimages/sku/s2597268-main-Sgrid.jpg?pb=2020-03-sephora-clean-2019'
            }
        }
    }
];

module.exports = {
    BASKET_TYPES,
    ROOT_BASKET_TYPES,
    MAIN_BASKET_TYPES,
    BOPIS_TYPES,
    DC_BASKET_TYPES,
    PRODUCTS,
    STORE_DETAILS
};
